import { render, staticRenderFns } from "./MineCollect.vue?vue&type=template&id=73b8f694&scoped=true&"
import script from "./MineCollect.vue?vue&type=script&lang=js&"
export * from "./MineCollect.vue?vue&type=script&lang=js&"
import style0 from "./MineCollect.vue?vue&type=style&index=0&id=73b8f694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b8f694",
  null
  
)

export default component.exports